import * as React from 'react';
import { get } from 'lodash';
import { reduxForm } from 'redux-form';

import Button from '@inqool/uas-web-core/es/components/controls/Button';
import { RemoteAutoCompleteField, RemoteAutoComplete } from '@components/form';
import { compose, withHandlers } from 'recompose';

const enhance = compose(
  withHandlers({
    onSubmit: ({ onSubmit, closeItem }) => data => {
      onSubmit(data);
      closeItem();
    }
  }),
  reduxForm({ form: 'module-address' })
);
export const View = props => {
  return (
    <div>
      <form className="layout" onSubmit={props.handleSubmit}>
        <RemoteAutoCompleteField
          id="type"
          name="type"
          label="Typ pracovního dne"
          component={RemoteAutoComplete}
          url="/metropolis/api/hr/workplan/calendar/day"
          labelFunction={o => get(o, 'label')}
        />
        <Button type="submit" label="Přidat intervaly" primary={true} style={{ margin: '16px 0 16px 16px' }} />
        <Button label="Zrušit" style={{ margin: '16px 0 16px 16px' }} onClick={props.closeItem} />
      </form>
    </div>
  );
};

export const OverviewAddPeriodsModal = enhance(View);



// WEBPACK FOOTER //
// ./src/modules/hr-overview/OverviewAddPeriodsModal.tsx